import { useFeatureGate } from '@statsig/react-bindings';
import { useAtomValue } from 'jotai';

import { AdditionalOptionsMenu, AdditionalOptionsMenuProps } from '../../components/AdditionalOptionsMenu';
import { telehealthMeasuresControlButtonEnabledGate } from '../../statsig/gates';
import { useGetClientSafetyGuard } from '../../useGetClientSafetyGuard';
import { useChatDrawerButtonUtils } from '../chat/useChatDrawerButtonUtils';
import { visitorMeasuresAtom } from '../state';

export function VisitorAdditionalOptionsMenuWrapper({ children }: Pick<AdditionalOptionsMenuProps, 'children'>) {
  const hasUnreadMessages = useChatDrawerButtonUtils().unreadMessagesCount > 0;
  const visitorMeasures = useAtomValue(visitorMeasuresAtom);
  const { value: measuresControlButtonEnabled } = useFeatureGate(telehealthMeasuresControlButtonEnabledGate);
  const { requiresSafetyGuards } = useGetClientSafetyGuard();
  const hasOutstandingMeasures = !!visitorMeasures?.length;
  const shouldShowVisualIndicator =
    hasUnreadMessages || (measuresControlButtonEnabled && hasOutstandingMeasures && requiresSafetyGuards === false);
  return (
    <AdditionalOptionsMenu shouldShowVisualIndicator={shouldShowVisualIndicator}>{children}</AdditionalOptionsMenu>
  );
}
